<div class="modal-body">
    <a class="mt-1 float-right" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
    <form id="siteForm" appPromptUnsubmitted (ngSubmit)="save()">
        <div class="card-body">
            <h5 class="form-group col-sm-12">
                Tree species
            </h5>
            <div class="form-group col-12">
                    <label for="name">Name</label>

                    <div class="form-control custom-select multiselect" id="partner">
                        <ng-select [items]="speciesDto" name="name"
                            [searchFn]="trimAndLower" [loading]="creatingNew" [(ngModel)]="listSpecies" multiple="false"
                            maxSelectedItems="1" bindLabel="species" (change)="onSelect(listSpecies)"
                            [appIsInvalid]="!listSpecies">
                            >
                        </ng-select>
                    </div>
                    <div class="invaild-feedback-select" *ngIf="isInvildSelect">
                        Name is Required.
                    </div>
            </div>

            <div class="form-group col-md-12">
                    <label for="name">Description</label>

                    <textarea class="form-control"
                        id="description" name="description"  [(ngModel)]="description" [appIsInvalid]="!description" rows="3" [disabled]="true" required></textarea>
                    <div class="invalid-feedback">
                        Description is Required.
                    </div>
            </div>

            <div class="form-group col-md-12">
                <label for="name">Amount</label>
                <input
                class="form-control"
                id="amount"
                name="amount"
                type="number"
                [appIsInvalid]="!treeSpecies.count || treeSpecies.count <= 0 || (treeSpecies.count | hasDecimal)"
                [(ngModel)]="treeSpecies.count">

         <div *ngIf="!treeSpecies.count && treeSpecies.count !== 0" class="invalid-feedback">
             The amount is required
         </div>

         <div *ngIf="treeSpecies.count <= 0" class="invalid-feedback">
             The amount should be greater than zero
         </div>

         <div *ngIf="treeSpecies.count | hasDecimal" class="invalid-feedback">
             The amount must be an integer value
         </div>

         <!-- <div *ngIf="treeSpecies.count > max" class="invalid-feedback">
             The amount of trees is greater than the planted trees.
         </div> -->
            </div>

            <div class="form-group col-md-12"  *ngIf="photoUrl">
                    <label for="name">Image</label>
                    <div
                        [style.background-size]="'cover'"
                        [appBackgroundUrl]="photoUrl" style="height: 260px !important;">
                    </div>
            </div>

            <div class="row mt-5">
                <div class="col-md-12 text-center">
                    <button class="btn btn-primary mr-3">Save</button>
                    <button type="button" class="btn btn-outline-dark" (click)="hideNavModal()">Cancel</button>
                </div>

            </div>
        </div>
    </form>
</div>

